import styled from 'styled-components';
import { device } from '@styles/tools/breakpoints.styles';
import { Button } from '@agilize/components-core';
import { ButtonProps } from '@agilize/components-core/dist/components/button/Button.types';

export const StyledButton = styled(Button)<ButtonProps>`
  ${device.desktop} {
    width: 175px;
  }
  ${device.mobile} {
    padding: 10px;
  }
  color: ${props => props.theme.colors.grey900};
`;

export const Title = styled.div`
  font-size: ${props => props.theme.fontSizes[2]};
  color: ${props => props.theme.colors.grey900};
`;

export const Description = styled.div`
  color: ${props => props.theme.colors.grey700};
  font-size: ${props => props.theme.fontSizes[1]};
`;
